import React, { Fragment } from "react";
import { GenErrorPage } from "../components/GenErrorPage";

export const LeaveEmbeddedSafari: React.SFC<any> = () => {

  const description = (
    <Fragment>
      It appears that you are accessing this page through a 3rd party window. Please use your Safari browser app by
      clicking the Safari icon in the bottom right of your screen.
    </Fragment>
  );

  return (
    <GenErrorPage
      title="Please Use Safari"
      description={description}
    />
  );
};



// WEBPACK FOOTER //
// ./src/screens/LeaveEmbeddedSafari.tsx